// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../types";

import gql from "graphql-tag";
import {
  GetSpaceCapacityEventFragmentDoc,
  GetSpaceCapacityProposalFragmentDoc,
} from "../../../Graphql-Utilities/getSpaceCapacity/getSpaceCapactiy.generated-types";
import { GetAddressProposalFragmentDoc } from "../../../Graphql-Utilities/getAddress/getAddress.generated-types";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProposalModalEventFragment = {
  __typename?: "Event";
  layoutID: string;
};

export type ProposalModalProposalFragment = {
  __typename?: "Proposal";
  ID: number;
  currency: string;
  baseCostTotal: number;
  baseCostDescription: string;
  message?: string | null;
  space: {
    __typename?: "SelfServeSpace";
    spaceName?: string | null;
    description?: string | null;
    venue?: {
      __typename?: "SelfServeVenue";
      name?: string | null;
      addressLine1?: string | null;
      city?: string | null;
      postalCode?: string | null;
      nearestTransit?: {
        __typename?: "NearestTransit";
        station?: string | null;
      } | null;
    } | null;
    spaceFeatures?: Array<{
      __typename?: "SelfServeSpaceFeature";
      ID?: number | null;
      name?: string | null;
    }> | null;
    spacePhotos?: Array<{
      __typename?: "SelfServeSpacePhoto";
      url?: string | null;
    }> | null;
    spatialConfigurations?: Array<{
      __typename?: "SelfServeSpatialConfiguration";
      name?: string | null;
      capacity?: number | null;
    }> | null;
  };
  extraCostItems?: Array<{
    __typename?: "ExtraCostItem";
    ID: number;
    description: string;
    quantity?: number | null;
    costPerUnit: number;
  }> | null;
  documents?: Array<{
    __typename?: "ProposalDocument";
    ID: number;
    URL: string;
    filename: string;
  }> | null;
};

export type ExtraCostItemFragment = {
  __typename?: "ExtraCostItem";
  ID: number;
  description: string;
  quantity?: number | null;
  costPerUnit: number;
};

export type ProposalModalRequestToBookMutationVariables = Types.Exact<{
  input: Types.ReqToBookIn;
}>;

export type ProposalModalRequestToBookMutation = {
  __typename?: "Mutation";
  requestToBook: {
    __typename?: "Proposal";
    eventID: number;
    status: Types.ProposalStatus;
    hostID: number;
    spaceID: number;
    baseCostDescription: string;
    currency: string;
    message?: string | null;
    fromDateTime: string;
    toDateTime: string;
    attendees: number;
    extraCostItems?: Array<{
      __typename?: "ExtraCostItem";
      description: string;
      costPerUnit: number;
    }> | null;
    documents?: Array<{
      __typename?: "ProposalDocument";
      ID: number;
      filename: string;
    }> | null;
  };
};

export const ProposalModalEventFragmentDoc = gql`
  fragment ProposalModalEvent on Event {
    ...GetSpaceCapacityEvent
  }
  ${GetSpaceCapacityEventFragmentDoc}
`;
export const ExtraCostItemFragmentDoc = gql`
  fragment ExtraCostItem on ExtraCostItem {
    ID
    description
    quantity
    costPerUnit
  }
`;
export const ProposalModalProposalFragmentDoc = gql`
  fragment ProposalModalProposal on Proposal {
    ID
    space {
      spaceName
      description
      venue {
        name
        nearestTransit {
          station
        }
      }
      spaceFeatures {
        ID
        name
      }
      spacePhotos {
        url
      }
    }
    currency
    baseCostTotal
    baseCostDescription
    extraCostItems {
      ...ExtraCostItem
    }
    message
    documents {
      ID
      URL
      filename
    }
    ...GetAddressProposal
    ...GetSpaceCapacityProposal
  }
  ${ExtraCostItemFragmentDoc}
  ${GetAddressProposalFragmentDoc}
  ${GetSpaceCapacityProposalFragmentDoc}
`;
export const ProposalModalRequestToBookDocument = gql`
  mutation ProposalModalRequestToBook($input: ReqToBookIn!) {
    requestToBook(input: $input) {
      eventID
      status
      hostID
      spaceID
      baseCostDescription
      extraCostItems {
        description
        costPerUnit
      }
      documents {
        ID
        filename
      }
      currency
      message
      fromDateTime
      toDateTime
      attendees
    }
  }
`;

export function useProposalModalRequestToBookMutation() {
  return Urql.useMutation<
    ProposalModalRequestToBookMutation,
    ProposalModalRequestToBookMutationVariables
  >(ProposalModalRequestToBookDocument);
}
